import React from 'react';
import ReactDOM from 'react-dom';
import guideContent from './guideContent';
import './GuideModal.css';

/**
 * "Guide" button that sits in section headers.
 * Props:
 *   sectionKey — key into guideContent (e.g. "overview", "nearby")
 *   variant    — "default" | "conversations" (adjusts styling context)
 */
export function GuideButton({ sectionKey, variant = 'default' }) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <button
        className={`guide-btn ${variant === 'conversations' ? 'guide-btn--conversations' : ''}`}
        onClick={() => setOpen(true)}
        aria-label="Open guide"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <span>Guide</span>
      </button>
      {open && <GuideModal sectionKey={sectionKey} onClose={() => setOpen(false)} />}
    </>
  );
}

/**
 * Modal overlay rendered via portal.
 */
function GuideModal({ sectionKey, onClose }) {
  const content = guideContent[sectionKey];

  if (!content) return null;

  const modal = (
    <div className="guide-modal-overlay" onClick={onClose}>
      <div className="guide-modal" onClick={(e) => e.stopPropagation()}>
        <div className="guide-modal__header">
          <h2 className="guide-modal__title">{content.title}</h2>
          <button className="guide-modal__close" onClick={onClose} aria-label="Close guide">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="guide-modal__body">
          {content.sections.map((section, i) => (
            <div key={i} className="guide-modal__section">
              {section.heading && (
                <h3 className="guide-modal__heading">{section.heading}</h3>
              )}
              {section.body && (
                <p className="guide-modal__text">{section.body}</p>
              )}
              {section.items && (
                <dl className="guide-modal__dl">
                  {section.items.map((item, j) => (
                    <div key={j} className="guide-modal__dl-row">
                      <dt className="guide-modal__dt">{item.term}</dt>
                      <dd className="guide-modal__dd">{item.definition}</dd>
                    </div>
                  ))}
                </dl>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
}

export default GuideModal;
